///purchasedraft/list
export const PURCHASE_DRAFT_LIST = "PURCHASE_DRAFT_LIST";
export const PURCHASE_DRAFT_LIST_SUCCESS = "PURCHASE_DRAFT_LIST_SUCCESS";
export const PURCHASE_DRAFT_LIST_FAIL = "PURCHASE_DRAFT_LIST_FAIL";
///purchasedraft/search
export const PURCHASE_DRAFT_SEARCH = "PURCHASE_DRAFT_SEARCH";
export const PURCHASE_DRAFT_SEARCH_SUCCESS = "PURCHASE_DRAFT_SEARCH_SUCCESS";
export const PURCHASE_DRAFT_SEARCH_FAIL = "PURCHASE_DRAFT_SEARCH_FAIL";
///purchasedraft/data
export const PURCHASE_DRAFT_DATA = "PURCHASE_DRAFT_DATA";
export const PURCHASE_DRAFT_DATA_SUCCESS = "PURCHASE_DRAFT_DATA_SUCCESS";
export const PURCHASE_DRAFT_DATA_FAIL = "PURCHASE_DRAFT_DATA_FAIL";
///purchasedraft/create
export const PURCHASE_DRAFT_CREATE = "PURCHASE_DRAFT_CREATE";
export const PURCHASE_DRAFT_CREATE_SUCCESS = "PURCHASE_DRAFT_CREATE_SUCCESS";
export const PURCHASE_DRAFT_CREATE_FAIL = "PURCHASE_DRAFT_CREATE_FAIL";
///purchasedraft/update
export const PURCHASE_DRAFT_UPDATE = "PURCHASE_DRAFT_UPDATE";
export const PURCHASE_DRAFT_UPDATE_SUCCESS = "PURCHASE_DRAFT_UPDATE_SUCCESS";
export const PURCHASE_DRAFT_UPDATE_FAIL = "PURCHASE_DRAFT_UPDATE_FAIL";
///purchasedraft/delete
export const PURCHASE_DRAFT_DELETE = "PURCHASE_DRAFT_DELETE";
export const PURCHASE_DRAFT_DELETE_SUCCESS = "PURCHASE_DRAFT_DELETE_SUCCESS";
export const PURCHASE_DRAFT_DELETE_FAIL = "PURCHASE_DRAFT_DELETE_FAIL";
///purchasedraft/converttopurchase
export const PURCHASE_DRAFT_CONVERT_TO_PURCHASE =
  "PURCHASE_DRAFT_CONVERT_TO_PURCHASE";
export const PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS =
  "PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS";
export const PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL =
  "PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL";
///purchasedraftstatus/list
export const PURCHASE_DRAFT_STATUS_LIST = "PURCHASE_DRAFT_STATUS_LIST";
export const PURCHASE_DRAFT_STATUS_LIST_SUCCESS =
  "PURCHASE_DRAFT_STATUS_LIST_SUCCESS";
export const PURCHASE_DRAFT_STATUS_LIST_FAIL =
  "PURCHASE_DRAFT_STATUS_LIST_FAIL";
///purchasedraftstatus/data
export const PURCHASE_DRAFT_STATUS_DATA = "PURCHASE_DRAFT_STATUS_DATA";
export const PURCHASE_DRAFT_STATUS_DATA_SUCCESS =
  "PURCHASE_DRAFT_STATUS_DATA_SUCCESS";
export const PURCHASE_DRAFT_STATUS_DATA_FAIL =
  "PURCHASE_DRAFT_STATUS_DATA_FAIL";
///purchasedraftstatus/create
export const PURCHASE_DRAFT_STATUS_CREATE = "PURCHASE_DRAFT_STATUS_CREATE";
export const PURCHASE_DRAFT_STATUS_CREATE_SUCCESS =
  "PURCHASE_DRAFT_STATUS_CREATE_SUCCESS";
export const PURCHASE_DRAFT_STATUS_CREATE_FAIL =
  "PURCHASE_DRAFT_STATUS_CREATE_FAIL";
///purchasedraftstatus/update
export const PURCHASE_DRAFT_STATUS_UPDATE = "PURCHASE_DRAFT_STATUS_UPDATE";
export const PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS =
  "PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS";
export const PURCHASE_DRAFT_STATUS_UPDATE_FAIL =
  "PURCHASE_DRAFT_STATUS_UPDATE_FAIL";
///purchasedraftstatus/delete
export const PURCHASE_DRAFT_STATUS_DELETE = "PURCHASE_DRAFT_STATUS_DELETE";
export const PURCHASE_DRAFT_STATUS_DELETE_SUCCESS =
  "PURCHASE_DRAFT_STATUS_DELETE_SUCCESS";
export const PURCHASE_DRAFT_STATUS_DELETE_FAIL =
  "PURCHASE_DRAFT_STATUS_DELETE_FAIL";
